/**

 * « إنشاء مستند » — client scope (6 types, one place).

 * عرض سعر · فاتورة أولية · أمر · فاتورة · بون تسليم · إشعار دائن

 */



export const CREATE_DOCUMENT_PICKER_META = [

  {

    id: 'quote',

    title: 'document_creation.picker_cards.quote.title',

    subtitle: 'document_creation.picker_cards.quote.subtitle',

    description: 'document_creation.picker_cards.quote.description',

  },

  {

    id: 'proforma',

    title: 'document_creation.picker_cards.proforma.title',

    subtitle: 'document_creation.picker_cards.proforma.subtitle',

    description: 'document_creation.picker_cards.proforma.description',

  },

  {

    id: 'purchase-order',

    title: 'document_creation.picker_cards.purchase-order.title',

    subtitle: 'document_creation.picker_cards.purchase-order.subtitle',

    description: 'document_creation.picker_cards.purchase-order.description',

  },

  {

    id: 'invoice',

    title: 'document_creation.picker_cards.invoice.title',

    subtitle: 'document_creation.picker_cards.invoice.subtitle',

    description: 'document_creation.picker_cards.invoice.description',

  },

  {

    id: 'delivery-note',

    title: 'document_creation.picker_cards.delivery-note.title',

    subtitle: 'document_creation.picker_cards.delivery-note.subtitle',

    description: 'document_creation.picker_cards.delivery-note.description',

  },

  {

    id: 'credit-note',

    title: 'document_creation.picker_cards.credit-note.title',

    subtitle: 'document_creation.picker_cards.credit-note.subtitle',

    description: 'document_creation.picker_cards.credit-note.description',

  },

];



export const CREATE_DOCUMENT_PICKER_DOC_IDS = CREATE_DOCUMENT_PICKER_META.map((d) => d.id);


